import React, { useState, useEffect } from "react";
import { Flex, Avatar, Layout, Typography, Divider, Drawer, Menu } from 'antd'
import { useRecoilState } from "recoil";
import { Outlet, useNavigate } from "react-router-dom";
import {
    LogoutOutlined, UploadOutlined, UserOutlined, ContainerOutlined, FileTextOutlined, DollarOutlined,
    FileProtectOutlined, UserSwitchOutlined, AuditOutlined,
    TrophyOutlined,
    KeyOutlined,
    MenuOutlined,
    CloseOutlined,
    ExperimentOutlined,
    StarOutlined
} from '@ant-design/icons';
import { isMobile } from "react-device-detect";
import { useToasts } from "react-toast-notifications";
import LOGORET from '../../images/logo-nova-retangular-branco.png'
import { titleize } from '../../service/util'
import { userState } from '../../service/database'

const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
    backgroundColor: '#215a8a'
};

const OutletRegistrado = (props) => {


    const navigate = useNavigate()
    const [user,] = useRecoilState(userState)


    const [items, setItems] = useState([

    ])

    const [openMenu, setOpenMenu] = useState(false)

    useEffect(() => {


        var aux = [{ label: "Home", icon: <UserOutlined />, key: "/registrado" },

        {
            label: <span style={{ color: 'white' }}>ART</span>, icon: <ContainerOutlined style={{ color: 'white' }} />, key: "/registrado/art"
        }
        ]

        if (user?.isprofissional === 1) {
            aux.push({
                label: <span style={{ color: 'white' }}>Comunicação de Resp. Técnica</span>,
                icon: <FileTextOutlined style={{ color: 'white' }} />, key: "Comunicação de Resp. Técnica",
                children: [
                    {
                        label: "Ativas", key: "/registrado/crt"
                    },
                     {
                        label: "Baixadas", key: "/registrado/crt/baixadas"
                    },
                    {
                        label: "Solicitações", key: "/registrado/crt/solicitacoes"
                    },

                ]
            })
        } else {

            aux.push({
                label: <span style={{ color: 'white' }}>Comunicação de Resp. Técnica</span>,
                icon: <FileTextOutlined style={{ color: 'white' }} />, key: "Comunicação de Resp. Técnica_PJ",
                children: [
                    {
                        label: "Ativas", key: "/registrado/crt-pj"
                    }
                ]
            })
        }

        aux.push({ label: "Financeiro", icon: <DollarOutlined />, key: "/registrado/financeiro" })
        aux.push({ label: "Declaração de Quitação", icon: <FileProtectOutlined />, key: "/registrado/declaracao" })
        aux.push({ label: "Oportunidades", icon: <TrophyOutlined />, key: "/registrado/oportunidades" })
        aux.push({ label: "Banco de Talentos", icon: <StarOutlined />, key: "/registrado/banco-de-talentos" })
        aux.push({ label: "Alterar Senha", icon: <KeyOutlined />, key: "/registrado/alterar-senha" })

        if (user?.isprofissional === 0)
            aux.push({ label: "Certificado", icon: <AuditOutlined />, key: "/registrado/certificado" })
        aux.push({ label: "Sair", icon: <LogoutOutlined />, key: "Sair" })


        setItems(aux)
    }, [])


    function renderMenu() {
        return <Menu theme="light" id="meucrqcemenu"
            style={{ backgroundColor: isMobile ? '#1a365c' : '#215a8a', color: 'white' }}
            mode="inline"
            defaultOpenKeys={['Comunicação de Resp. Técnica', 'ART', 'Comunicação de Resp. Técnica_PJ']}
            defaultSelectedKeys={['1', 'Comunicação de Resp. Técnica', 'ART', 'Comunicação de Resp. Técnica_PJ']}
            items={items}
            onClick={(item) => {
                if (item.key === 'Sair') {
                    navigate("/login")
                } else {
                    navigate(item.key)
                    setOpenMenu(false)
                }
            }} />

    }


    return <Layout  >
        {isMobile ? <div></div> :
            <Layout.Sider
                width={300}
                style={siderStyle}
                theme="light"
                breakpoint="lg"
                collapsedWidth="0"
                onBreakpoint={broken => {
                    //  console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                    console.log(collapsed, type);
                }}
            >
                <Flex vertical>
                    <div className="demo-logo-vertical" />
                    <Flex vertical justify="center" align="center" style={{ padding: 5, marginTop: 20 }} >
                        {/* <img height={50} alt="logor" src={LOGO} /> */}
                        <span style={{ fontSize: '1.3em' }}><span style={{ color: '#07b15f' }}>MEU</span><strong style={{ color: 'white' }}>CRQCE</strong></span>
                    </Flex>
                    <Divider />
                    {renderMenu()}

                    <Divider />
                </Flex>

            </Layout.Sider>
        }
        <Layout>
            <Layout.Header style={{ padding: 0, backgroundColor: 'white', borderBottomWidth: 1, borderColor: '#e0e0e0', borderBottomStyle: 'solid' }} >
                <Flex justify="space-between" align="center">
                    <Flex align="center" style={{ padding: 5 }}>
                        {isMobile && <MenuOutlined size={24} onClick={() => setOpenMenu(true)} />}
                        <img height={50} alt="logor" src={LOGORET} />
                    </Flex>
                    <Flex style={{ marginRight: 5 }} gap={5}>
                        <Avatar size={'small'} src={<UserOutlined />} style={{ color: 'whitesmoke', backgroundColor: 'lightgray' }} />
                        <Typography.Text style={{ fontSize: '1.1em' }}> {"Olá "}{titleize(user?.nome?.split(' ')[0])} </Typography.Text>
                    </Flex>
                </Flex>
            </Layout.Header>
            <Layout.Content style={{ margin: '24px 16px 0' }}>
                <div
                    style={{
                        padding: isMobile ? 2 : 24,
                        minHeight: 360
                    }}
                >
                    <Outlet />
                </div>
            </Layout.Content>
            <Layout.Footer style={{ textAlign: 'center' }}>
                <Divider />
                ©{new Date().getFullYear()} - Desenvolvido com muito ❤️ pelo <span style={{ fontWeight: 600 }}>CRQCE</span>
            </Layout.Footer>
        </Layout>


        <Drawer
            closeIcon={<CloseOutlined style={{ color: 'white' }} onClick={() => setOpenMenu(false)} />}
            styles={{
                header: {
                    backgroundColor: '#1a365c'
                }
            }}
            style={{ backgroundColor: '#1a365c' }}
            placement="left"
            title={<Flex vertical justify="center" align="center"  >
                {/* <img height={50} alt="logor" src={LOGO} /> */}
                <span style={{ fontSize: '1.3em' }}><span style={{ color: '#07b15f' }}>MEU</span><strong style={{ color: 'white' }}>CRQCE</strong></span>
            </Flex>}
            open={openMenu}
            onClose={() => setOpenMenu(false)}>
            {renderMenu()}
        </Drawer>

    </Layout>

}

export default OutletRegistrado